(function() {
  var SelectBox, ValidationEngine, accounting,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass("core::ValidationEngine");

  SelectBox = App.loadClass("core::SelectBox");

  accounting = App.loadClass("bower::accounting/accounting");

  exports.RuppOrdersDialogLinesHandler = (function(superClass) {
    extend(RuppOrdersDialogLinesHandler, superClass);

    function RuppOrdersDialogLinesHandler() {
      this.afterLoadLayout = bind(this.afterLoadLayout, this);
      return RuppOrdersDialogLinesHandler.__super__.constructor.apply(this, arguments);
    }

    RuppOrdersDialogLinesHandler.prototype.init = function() {
      this.everythingLoaded = false;
      this.layoutUrl = 'backend/grower/rupp-orders/load-layout-lines';
      this.layoutSelector = "#orders_steps_container";
      this.loadLayout();
      return this.fetchPrices = 0;
    };

    RuppOrdersDialogLinesHandler.prototype.afterLoadLayout = function(selector, response) {
      var j, len, qty, ref, ref1, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      this.line_id = 0;
      $('#btn_add_line').bind('click', function() {
        var brands, data, line_id, ref1, ref2, ref3, ref4, ref5, technologies;
        line_id = $(this).data('id');
        $(this).removeData('id');
        if (line_id == null) {
          line_id = ths.line_id;
        }
        data = $('.add-line-tmpl').render({
          line_id: line_id
        });
        data = $($.parseHTML(data));
        data.appendTo('.orders_lines_container');
        data.find('.order-data').attr('data-dynamic-btn', '#btn_add_line');
        data.find('.order-data').attr('data-dynamic-id', line_id);
        data.find('.btn_line_delete').attr('data-dynamic-id', line_id);
        data.find('.txt_line_units').mask('?9999999', {
          placeholder: ""
        });
        brands = ths.taffyObjects['hybrids']([
          {
            "available": {
              "gt": 0
            },
            "disabled": {
              "is": false
            }
          }, {
            "id": {
              "is": (ref1 = parseInt((ref2 = ths.parent.saveData.lines[line_id]) != null ? ref2.hybrids_id : void 0)) != null ? ref1 : ""
            }
          }
        ]).order('display_name').distinct('id', 'display_name');
        technologies = ths.taffyObjects['hybrids']([
          {
            "available": {
              "gt": 0
            },
            "disabled": {
              "is": false
            }
          }, {
            "id": {
              "is": (ref3 = parseInt((ref4 = ths.parent.saveData.lines[line_id]) != null ? ref4.hybrids_id : void 0)) != null ? ref3 : ""
            }
          }
        ]).order('trait_packages_name').distinct('trait_packages_id', 'trait_packages_name');
        SelectBox.render(technologies, $(data).find('.sel_line_technology'));
        SelectBox.render(brands, $(data).find('.sel_line_brand'));
        ths.line_id = parseInt(line_id) + 1;
        return (ref5 = ths.validator) != null ? ref5.revalidateInput('.validate-lines') : void 0;
      });
      $('.orders_lines_container').delegate('.btn_line_delete', 'click', function(e) {
        ths.parent.deleteFormData('lines', $(this).data('dynamic-id'));
        return $(this).closest('.line_header').remove();
      });
      $('.orders_lines_container').delegate('.sel_line_technology', 'change', function(e) {
        var criteria, current, dropdown, hid, line_id, ref1, ref2, ref3, stage, technology, technology_id, validBrands;
        ths.fetchPrices++;
        line_id = $(this).data('dynamic-id');
        technology_id = $(this).val();
        criteria = {};
        if (technology_id !== '') {
          criteria = {
            'trait_packages_id': {
              '==': technology_id
            }
          };
        }
        stage = (ref1 = (ref2 = ths.parent.saveData.lines[line_id]) != null ? ref2.status_name : void 0) != null ? ref1 : "";
        if (stage === "") {
          criteria['available'] = {
            "gt": 0
          };
        } else if (stage === "Ordered") {
          hid = ths.parent.saveData.lines[line_id].hybrids_id;
          technology = $.extend({
            "available": {
              "gt": 0
            }
          }, criteria);
          current = $.extend({
            "id": {
              "is": hid
            }
          }, criteria);
          criteria = [technology, current];
        }
        validBrands = ths.taffyObjects["hybrids"](criteria).distinct('id', 'display_name');
        dropdown = $(this).closest('.line_header').find('.sel_line_brand');
        SelectBox.render(validBrands, dropdown);
        if (!technology_id) {
          dropdown.val('');
          if ((ref3 = ths.validator) != null) {
            ref3.revalidateInput(dropdown);
          }
        }
        ths.fetchPrices--;
        return ths.updatePrices();
      });
      $('.orders_lines_container').delegate('.sel_line_brand', 'change', function(e) {
        var column_name, hybrid, price, sel_tmt, tmts, val, zone_name;
        ths.fetchPrices++;
        $(this).closest('tr').find('.validate-hybrid-avail').data('validate-group', $(this).val());
        hybrid = ths.taffyObjects["hybrids"]({
          'id': {
            '==': $(this).val()
          }
        }).select('trait_packages_id', 'available_treatments', 'default_treatment_id');
        if (hybrid.length) {
          $(this).closest('.line_header').find('.sel_line_technology').val(hybrid[0][0]).change();
          tmts = hybrid[0][1];
        } else {
          tmts = [];
        }
        sel_tmt = $(this).closest('.line_header').find('.sel_line_treatment');
        val = sel_tmt.val();
        SelectBox.render(tmts, sel_tmt);
        if (val) {
          sel_tmt.val(val);
        } else if (hybrid.length) {
          sel_tmt.val(hybrid[0][2]);
        }
        sel_tmt.trigger('change');
        zone_name = ths.taffyObjects['zones']({
          'id': {
            '==': ths.parent.saveData.pricing_zones_id
          }
        }).select('name')[0];
        if (zone_name) {
          column_name = (function() {
            switch (zone_name) {
              case '1 - WC IN':
                return 'rupp_price_1wcin';
              case '3 - NW OH MI':
                return 'rupp_price_3nwohmi';
              case '4 - SE OH PAS':
                return 'rupp_price_4seohpas';
              case '9 - E - IN':
                return 'rupp_price_9ein';
            }
          })();
        } else {
          column_name = "rupp_price";
        }
        price = ths.taffyObjects["hybrids"]({
          'id': {
            '==': $(this).val()
          }
        }).select(column_name)[0];
        $(this).parents('tr').find('.txt_line_unit_price').val(price);
        ths.fetchPrices--;
        return ths.updatePrices();
      });
      $('.orders_lines_container').delegate('.sel_line_treatment', 'change', function(e) {
        var t, tmt;
        ths.fetchPrices++;
        tmt = $(this).parents('tr').find('.sel_line_treatment').val();
        t = ths.taffyObjects["treatment_prices"]({
          'id': {
            '==': tmt
          }
        }).first();
        $(this).parents('tr').find('.txt_line_tmt_price').val(t.price);
        ths.fetchPrices--;
        return ths.updatePrices();
      });
      $('.orders_lines_container').delegate('.txt_line_units', 'change', function(e) {
        var brand, h;
        ths.fetchPrices++;
        brand = $(this).parents('tr').find('.sel_line_brand').val();
        h = ths.taffyObjects["hybrids"]({
          'id': {
            '==': brand
          }
        }).first();
        ths.fetchPrices--;
        return ths.updatePrices();
      });
      $('.orders_lines_container').delegate('.txt_line_unit_price, .txt_line_tmt_price', 'change', function(e) {
        var input, money;
        input = $(e.target);
        money = parseFloat(input.val()).toFixed(2);
        if (money === 'NaN') {
          money = '';
        }
        input.val(money);
        return ths.updatePrices();
      });
      if (this.parent.editable) {
        this.validator = new ValidationEngine();
        this.validator.stopValidating();
        this.validator.makeFormValidator('lines', '#lines_container', '#lines_errors', (function(_this) {
          return function(valid) {
            if (valid) {
              return _this.parent.gotoNext();
            }
          };
        })(this));
        this.validator.registerRule({
          selector: '.validate-lines',
          text: 'You must have at least one line on the order',
          func: function(elem) {
            return elem.closest('table').find('tbody tr').length > 0;
          }
        });
        this.validator.registerRule({
          selector: '.validate-hybrid-avail',
          text: function(elems, name) {
            var h, hybrid_id;
            hybrid_id = parseInt($(elems[0]).data('validate-group'));
            h = ths.taffyObjects["hybrids"]({
              id: {
                '==': hybrid_id
              }
            }).first();
            return "There are not enough units of " + h.display_name + " to fulfill your request. " + h.display_name + "'s availability is " + h.available + " units";
          },
          group: {
            attr: 'validate-group',
            name: 'Hybrid %g'
          },
          func: function(elems) {
            var brand, elem, hybrid, hybrid_id, index, j, len, line, old_units, qty, ref1, units;
            qty = 0;
            for (j = 0, len = elems.length; j < len; j++) {
              elem = elems[j];
              elem = $(elem);
              if (!elem.is('.txt_line_units')) {
                continue;
              }
              brand = $(elem.parents('tr').find('.sel_line_brand')[0]);
              units = $(elem.parents('tr').find('.txt_line_units')[0]);
              if (!brand.val() || !units.val()) {
                continue;
              }
              qty += parseInt(units.val());
            }
            hybrid_id = parseInt($(elems[0]).data('validate-group'));
            old_units = 0;
            ref1 = ths.parent.saveData.lines;
            for (index in ref1) {
              line = ref1[index];
              if (parseInt(line.original_hybrids_id) === hybrid_id) {
                old_units += parseInt(line.original_qty);
              }
            }
            hybrid = ths.taffyObjects["hybrids"]({
              id: {
                '==': hybrid_id
              }
            }).first();
            if (qty <= old_units) {
              return true;
            }
            return qty <= parseInt(hybrid.available) + old_units;
          }
        }, this.validator.registerRule({
          selector: 'input[name=qty]',
          text: 'You may not increase the quantity on a disabled product',
          func: (function(_this) {
            return function(elem) {
              var brand, disabled, new_qty, old_qty;
              brand = elem.closest('tr').find('.sel_line_brand').val();
              disabled = _this.taffyObjects['hybrids']({
                'id': {
                  '==': brand
                }
              }).select('disabled')[0];
              if (disabled) {
                old_qty = elem.attr('data-orig-qty');
                new_qty = elem.val();
                return parseInt(new_qty) <= parseInt(old_qty);
              }
              return true;
            };
          })(this)
        }));
      }
      this.parent.loadFormData();
      ref1 = $('input[name=qty]');
      for (j = 0, len = ref1.length; j < len; j++) {
        qty = ref1[j];
        $(qty).attr('data-orig-qty', $(qty).val());
      }
      this.parent.dialog.find('.message_writer').message_writer({
        autoHide: false
      });
      this.everythingLoaded = true;
      return this.updatePrices();
    };

    RuppOrdersDialogLinesHandler.prototype.updatePrices = function() {
      if (!this.everythingLoaded) {
        return;
      }
      if (this.fetchPrices > 0) {
        return;
      }
      this.parent.saveFormData();
      return $.post('backend/grower/rupp-orders/new-pricing-lines', JSON.stringify(this.parent.saveData), (function(_this) {
        return function(data) {
          var arr, i, results, row;
          if (data == null) {
            return $('.line_header .unit_price,.tmt_price,.ext_price').text('');
          } else {
            data = $.parseJSON(data);
            results = [];
            for (i in data) {
              arr = data[i];
              row = $(".sel_line_brand[data-dynamic-id='" + i + "']").closest('tr');
              if (!arr['ext_price']) {
                arr['ext_price'] = 0;
              }
              results.push(row.find('.ext_price').text(accounting.formatMoney(arr['ext_price'])));
            }
            return results;
          }
        };
      })(this));
    };

    RuppOrdersDialogLinesHandler.prototype.afterLoadData = function() {
      return $('#btn_orders_next').prop('disabled', false);
    };

    return RuppOrdersDialogLinesHandler;

  })(Handler);

}).call(this);
